/**
 * 指标英文说明（Tooltip / 首页列表等统一引用）
 */
export const METRIC_TIPS = {
  sumAnchor:
    'This measures the total cumulative number of live streamers for the game or category on a daily basis for the time period selected.',
  sumLenth:
    'This measures the cumulative number of hours streamed for the game, category, or individual streamer across the time period selected.',
  sumGift:
    'This measures the cumulative value of tips and virtual gifts that streamers receive within the game, the category, or as an individual streamer. This is measured in RMB and converted to USD.',
  sumFans:
    'For games, this measures the daily average number of subscribers that a streamer of a game or category has during the selected time period. For streamers, this measures the total number of subscribers they have to their channel.',
  sumHot:
    "This index is based on the daily average value of the three streaming platforms’ own algorithms. It provides a rating of each game’s number of viewers, hours streamed, and number of virtual gifts or tips donated to streamers.",
  sumNiko:
    'A weighted index estimated by Niko based on an algorithm which approximates the number of active viewers for each streamer, game, and category. This is a cumulative figure for the period selected.',
}
